import {
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from '@mui/material';
import { Container } from '@mui/system';
import React, { useEffect } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { OrderModel } from '../../../config/types/models/OrderModel';
import { useChangeProductStatus } from '../../../hooks/order/useChangeProductStatus';

type IProps = {
  order: OrderModel;
};
function OrderFunctions({ order }: IProps) {
  const t = useTranslate();
  const [isPaid, setIsPaid] = React.useState<boolean>(false);
  const [paymentMethod, setPaymentMethod] = React.useState('pending');

  const saveMutation = useChangeProductStatus();
  const notify = useNotify();
  useEffect(() => {
    setIsPaid(order.paymentStatus === 'paid' ? true : false);
    setPaymentMethod(order.paymentMethod);
  }, [order]);

  const onSave = () => {
    saveMutation.mutate(
      {
        orderId: order.id,
        isPaid,
        paymentMethod: paymentMethod,
      },
      {
        onSuccess: () => {
          notify(t('orderUpdated'));
        },
        onError: () => {
          notify(t('orderUpdateError'));
        },
      }
    );
  };

  return (
    <Container
      sx={{ border: '1px solid #3c3c3c50', padding: 1, borderRadius: 1 }}
    >
      <Grid container justifyContent={'center'} alignItems='center'>
        <Grid item lg={4} md={4} sm={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  defaultChecked
                  value={isPaid}
                  checked={isPaid}
                  onChange={() => setIsPaid(!isPaid)}
                />
              }
              label={t('isPaid')}
            />
          </FormGroup>
        </Grid>
        <Grid item lg={4} md={4} sm={12}>
          <FormControl fullWidth>
            <InputLabel id='paymentMethods'>{t('paymentMethod')}</InputLabel>
            <Select
              labelId='paymentMethods'
              value={paymentMethod}
              label={t('paymentMethod')}
              onChange={(e) => setPaymentMethod(e.target.value as string)}
              variant='standard'
            >
              <MenuItem value={'cash'}>{t('cash')}</MenuItem>
              <MenuItem value={'bank'}>{t('bank')}</MenuItem>
              <MenuItem value={'quickpay'}>{t('quickpay')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item lg={4} md={4} sm={12}>
          <Button onClick={onSave} sx={{ width: '100%', height: '100%' }}>
            {t('save')}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}

export default OrderFunctions;
